import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import useAuthStore from '../store/authStore';

export function usePushNotificacao() {
  const usuario = useAuthStore(s => s.usuario);

  useEffect(() => {
    if (!usuario?.uid) return;

    let unsubForeground = () => {};

    const registrar = async () => {
      try {
        // Importação dinâmica para não quebrar browsers sem suporte
        const { messaging } = await import('../firebase');
        if (!messaging) return;

        // Ler vapidKey gravada pelo admin em parametros/default
        const snap = await getDoc(doc(db, 'parametros', 'default'));
        const vapidKey = snap.data()?.vapidKey;
        if (!vapidKey) return;

        const permissao = await Notification.requestPermission();
        if (permissao !== 'granted') return;

        const reg = await navigator.serviceWorker.ready;
        const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: reg });
        if (!token) return;

        // Persistir token só se mudou (evita write desnecessário)
        const usuSnap = await getDoc(doc(db, 'usuarios', usuario.uid));
        if (usuSnap.data()?.fcmToken !== token) {
          await updateDoc(doc(db, 'usuarios', usuario.uid), { fcmToken: token });
        }

        // Handler de mensagens com app em foreground (evita notificação dupla)
        unsubForeground = onMessage(messaging, () => {});
      } catch (e) {
        // Silencioso: usuário pode ter negado permissão ou SW não registrado
        if (e.code !== 'messaging/permission-blocked') {
          console.warn('Push setup:', e.message);
        }
      }
    };

    registrar();
    return () => unsubForeground();
  }, [usuario?.uid]);
}
